import PropTypes from "prop-types"
import React from "react"
import { useStoreActivities } from "../hooks/usePartnerSignupApi"

const StoreActivitySelect = ({ name, value, onChange, onBlur, invalid }) => {
  const { activities, loading, error, reload } = useStoreActivities()

  if (error) {
    return (
      <div className="partner-inline-error">
        <span>{error}</span>
        <button type="button" onClick={reload}>Réessayer</button>
      </div>
    )
  }

  return (
    <select name={name} value={value} onChange={onChange} onBlur={onBlur} className={invalid ? "is-invalid" : ""} disabled={loading}>
      <option value="">{loading ? "Chargement..." : "Sélectionnez votre secteur"}</option>
      {activities.map(activity => (
        <option value={activity.id || activity["@id"]?.split("/").pop()} key={activity.id || activity["@id"]}>
          {activity.name || activity.label}
        </option>
      ))}
    </select>
  )
}

StoreActivitySelect.propTypes = {
  invalid: PropTypes.bool,
  name: PropTypes.string.isRequired,
  onBlur: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
}

export default StoreActivitySelect
